import React from 'react';
import renderIf from 'render-if';
import { Tab, Tabs } from 'react-toolbox/lib/tabs';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component

import styles from './CoachTabs.scss';// to import local scss fle

class CoachTabs extends React.Component {
  static propTypes = {
    tabListener: PropTypes.func.isRequired,
    division: PropTypes.string.isRequired,
  };
  state = {
    index: 0,
    fixedIndex: 1,
    inverseIndex: 1,
  };

  handleTabChange = (index) => {
    this.setState({ index });
    this.props.tabListener(index);
  };

  handleActive = () => {
        // eslint-disable-next-lint
  };

  render() {
    const { division } = this.props;
    const renderD1Tab = renderIf(division === 'D1');
    return (
      <div className={cn('col s12', styles.container)}>
        <Tabs index={this.state.index} onChange={this.handleTabChange}>
          <Tab label="My Requests" onActive={this.handleActive} activeClassName={styles.activeClass} />
          <Tab label="Postings" activeClassName={styles.activeClass} />
          <Tab label="Recommendations" activeClassName={styles.activeClass} />
          {renderD1Tab(
            <Tab label="D1 Students" activeClassName={styles.activeClass} />,
          )}
        </Tabs>
      </div>
    );
  }
}

export default CoachTabs;



// WEBPACK FOOTER //
// ./src/components/CoachTabs/CoachTabs.js